import * as UTILS from "./utils";
// import * as OPTIONS from "../option-fields";

// This file stores initial data that is either hard coded or is passed in via data attributes on the root node.
export const rootNode = document.getElementById("spektrixBookingPathway");

// Hard coded data
export const DEFAULT_TICKET_TYPE = "Standard Ticket";
export const VENUE_ATTRIBUTE_NAME = "FestivalKingsStudio";
export const HAS_TICKET_DONATIONS = false;
export const HAS_LOCATION_FILTERS = true;
export const USE_IFRAMES_FROM = null;
export const USE_IFRAME_BASKET = false;
export const USE_IFRAME_ACCOUNT = false;
export const HAS_CUSTOM_PLAN_IMAGES = true;
export const ACCOUNT_AREAS = [
    {
        title: "Account Overview",
        description: "",
        link: "/account",
        icon: "",
    },
    {
        title: "Orders & tickets",
        description: "View orders and download tickets",
        link: "/account/orders",
        icon: "ticket",
    },
    {
        title: "Membership & offers",
        description: "View and edit your membership",
        link: "/account/memberships",
        icon: "idcard",
    },
    {
        title: "Help & FAQs",
        description: "View more information",
        link: "/account/help",
        icon: "questionmark",
    },
    {
        title: "Preferences",
        description: "View and edit your preferences",
        link: "/account/preferences",
        icon: "cog",
    },
    {
        title: "My details",
        description: "View and edit your account details ",
        link: "/account/details",
        icon: "avatar",
    },
    {
        title: "Payments",
        description: "View and edit your card details",
        link: "/account/payments",
        icon: "card",
    },
];
export const COLORS = [
    "#FA4F00", // orange-red
    "#3971E2", // strong blue
    "#109121", // forest green
    "#E912B7", // bright pink
    "#D70007", // deep red
    "#7677A6", // slate
    "#8E33FF", // purple
    "#EC5F73", // pink-red
    "#2E8267", // dark teal
    "#9520AA", // dark purple

    "#FFEA33", // bright yellow
    "#33FF76", // mint green
    "#D99020", // muted orange
    "#33FFD7", // aqua
    "#E22B15", // red-orange
    "#FFBD33", // warm yellow
    "#10B6A9", // teal
    "#AAC800", // olive green
    "#ED60FF", // light magenta
    "#00C73F", // vivid green
    "#FC8308", // orange
    "#1FDAFF", // sky blue
    "#33A1FF", // light blue
    "#A1FF33", // lime green
];

// Initial data (passed via data attributes)
// URL's
export const SITE_URL = rootNode?.getAttribute("site-url");
export const AJAX_URL = SITE_URL + "/wp-admin/admin-ajax.php";
export const DOMAIN_NAME =
    rootNode && rootNode.getAttribute("domain-name")
        ? rootNode.getAttribute("domain-name")
        : "https://system.spektrix";
export const CLIENT_NAME = rootNode?.getAttribute("client-name");
export const SPEKTRIX_API_URL = `${DOMAIN_NAME}/${CLIENT_NAME}/api/v3`;
export const SPEKTRIX_PLUGIN_URL = `${SITE_URL}/wp-content/uploads/cog-wp-spektrix`;
// Event related data
export const INSTANCE =
    rootNode && JSON.parse(rootNode.getAttribute("instance"));
export const TAGS = rootNode && JSON.parse(rootNode.getAttribute("tags"));
export const EVENT = INSTANCE?.event;
export const INSTANCE_ID = INSTANCE?.instance_id;
export const PLAN_ID = INSTANCE?.plan_id;
export const INSTANCE_PRICELIST =
    INSTANCE && INSTANCE.pricelist && JSON.parse(INSTANCE.pricelist).prices;
export const INSTANCE_PRICELIST_WITH_COMMISSION =
    UTILS.addCommissionToPriceList(INSTANCE_PRICELIST);
export const SUPPLEMENTARY_INSTANCES =
    INSTANCE && JSON.parse(INSTANCE.supplementary_instances);
export const PRICE_DATA = INSTANCE?.price_data;
export const PRICE_TICKETS = PRICE_DATA?.tickets;
export const PRICE_BANDS = PRICE_DATA?.bands;
export const DEFAULT_TICKET_PRICEBANDS =
    UTILS.getBandsByTicketType(DEFAULT_TICKET_TYPE);
export const STATUS = INSTANCE && JSON.parse(INSTANCE.status);
export const ATTRIBUTES =
    INSTANCE && INSTANCE.attributes && JSON.parse(INSTANCE.attributes);
export const HAS_BEST_AVAILABLE = ATTRIBUTES?.hasBestAvailableOverlay;
export const TURN_OFF_VACANCY_RESTRICTION = INSTANCE?.turn_off_vacancy_restriction ?? false;
